import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { useRillContext } from "../../rill/RillReact/share/base";

function TablistNav({ name, options, defaultActive, callback = () => {} }) {
  const {
    locals: { query = {}, path },
  } = useRillContext();

  const active = defaultActive || get(query, name);
  return (
    <nav role="tablist">
      <input type="hidden" name={name} value={active} />
      {map(options, ({ value, text, href, IconImg = "", dataStatus }) => {
        const searchString = `${encodeURIComponent(name)}=${encodeURIComponent(
          value
        )}`;

        const newHref = href ? href : `/actions/refresh?${searchString}`;
        return (
          <a
            key={value}
            onClick={() => {
              callback(value);
            }}
            href={newHref}
            aria-current={
              (
                href
                  ? path === href || value === active
                  : query[name]
                  ? path.includes(searchString) || value === query[name]
                  : value === active || path.includes(searchString)
              )
                ? true
                : undefined
            }
            role="link"
            data-status={dataStatus}
          >
            {IconImg && <IconImg />}
            {text}
          </a>
        );
      })}
    </nav>
  );
}

export default TablistNav;
